import React from 'react'
import { observer } from 'mobx-react-lite'
import InitialAvatar from 'shared/components/InitialAvatar/InitialAvatar'
import { noteTakerStore } from 'shared/stores/noteTakerStore'
import AutoGrowTextarea from './AutoGrowTextarea'
import s from '../NoteTakerDrawer.module.scss'

const ActionItemDraftRow = observer(({ studentName, studentId }) => {
	const draft = noteTakerStore.actionItemDraft
	if (!draft) return null

	const isStudentOwned = draft.ownerType === 'student'
	const ownerLabel = isStudentOwned ? studentName.split(' ')[0] : 'You'
	const canSave = String(draft.text || '').trim().length > 0

	return (
		<div className={[s.actionRow, s.actionRowDraft].join(' ')}>
			<span className={s.checkbox} />
			<div className={s.actionTextGroup}>
				<div className={s.actionMainRow}>
					<div className={s.ownerPill}>
						<InitialAvatar
							name={ownerLabel}
							size={22}
							studentId={isStudentOwned ? studentId : undefined}
						/>
						<select
							className={s.ownerSelect}
							value={draft.ownerType}
							onChange={event =>
								noteTakerStore.updateActionItemDraft({
									ownerType: event.target.value,
									ownerLabel: event.target.value === 'student' ? ownerLabel : 'You',
								})
							}
						>
							<option value="you">You</option>
							<option value="student">{studentName.split(' ')[0]}</option>
						</select>
					</div>
					<div className={s.actionInputWrap}>
						<AutoGrowTextarea
							className={s.actionInput}
							value={draft.text}
							onChange={event =>
								noteTakerStore.updateActionItemDraft({ text: event.target.value })
							}
							placeholder="Describe the action item..."
							autoFocus
						/>
					</div>
				</div>
				{draft.error ? <span className={s.inlineError}>{draft.error.message}</span> : null}
			</div>
			<div className={s.draftActions}>
				<button
					type="button"
					className={s.secondaryButton}
					onClick={() => noteTakerStore.cancelActionItemDraft()}
					disabled={draft.saveStatus === 'saving'}
				>
					Cancel
				</button>
				<button
					type="button"
					className={s.primaryButton}
					onClick={() => noteTakerStore.saveActionItemDraft(studentName)}
					disabled={!canSave || draft.saveStatus === 'saving'}
				>
					{draft.saveStatus === 'saving' ? 'Saving...' : 'Save'}
				</button>
			</div>
		</div>
	)
})

export default ActionItemDraftRow
